import React, {useEffect, useState} from 'react';
import {getCurrentSecond, isOpenNow, timeToClose} from "../../PhoneHours/logic";
import {hideWidget, startFiveNineChat} from "./fiveNineChat";
import {analyseChatEvents, tryTrapChatEvents} from "./chatEvents";
import clsx from 'clsx';

const isDev = (process.env.NODE_ENV == 'development');
const INTERVAL = isDev ? 1000 : 10_000;

export default function FiveNineStarter({config, chatAvailable, pageInfo}) {

  // for availability
  const [localStartSecond,] = useState(getCurrentSecond); // no setter
  const [currentSecond, setCurrentSecond] = useState(getCurrentSecond);

  //
  const chatEvents = globalThis.CHAT_EVENTS || [];

  const [chatStatus, setChatStatus] = useState(() => analyseChatEvents(chatEvents));

  useEffect(() => {
    globalThis.CHAT_EVENTS ||= [];

    // set up event handlers, do this only once.
    tryTrapChatEvents({config});

    window.setInterval(() => {
      // caution, constants retain their original value in here.
      // use setTimeout if you need it to change
      // console.log(`tick..... now=${now}`);

      setCurrentSecond(getCurrentSecond);
    }, INTERVAL)
  }, []);

  useEffect(() => {
    let report = analyseChatEvents(chatEvents);
    setChatStatus(report);
  }, [chatEvents?.length]);

  // const openNow = isOpenNow({
  //   ...chatAvailable,
  //   elapsed: (currentSecond - localStartSecond)
  // });

  const ttc = timeToClose({
    ...chatAvailable,
    elapsed: (currentSecond - localStartSecond)
  });

  const htc = Math.floor(ttc / 3600);

  function handleClick(e) {
    e.preventDefault();

    startFiveNineChat({config, pageInfo});
  }

  // FIXME FIXME DEV ONLY
  // FIXME FIXME DEV ONLY
  // FIXME FIXME DEV ONLY
  // FIXME FIXME DEV ONLY
  // FIXME FIXME DEV ONLY
  if (!isDev) return null;

  // FIXME FIXME DEV ONLY
  // FIXME FIXME DEV ONLY
  // FIXME FIXME DEV ONLY
  return <div className="fixed top-8 left-4 z-1000 bg-white p-2 text-sm">
    <div className="grid grid-cols-2">
      <div>
        <button className="btn-secondary px-4 py-2 text-sm"
          type="button" onClick={handleClick}>
          <span className="fa fad fa-user-headset mr-2"/> chat!
        </button>
      </div>
      { chatStatus?.open && <div>
        <a onClick={() => hideWidget({})}>
          close widget
        </a>
      </div>}
    </div>

    <div>
      agents go away in {htc} hrs {ttc - (3600 * htc)} sec
    </div>
    <div className={clsx('text-sm', chatStatus.open ? 'text-green-800' : 'text-orange-800')}>
      {JSON.stringify(chatStatus,null,2)}
    </div>
    <div className="text-xs">
      {chatEvents.map((evt, i) =>
        <div key={i}>{JSON.stringify(evt, null, 2)}</div>)}
    </div>
  </div>;
}
